import { Injectable } from "@angular/core";
import { TokenStorageService } from "../../core/services/token-storage.service";
import { GenericService } from "../../core/services/generic.service";
import { and, collection, collectionData, orderBy, query, QueryCompositeFilterConstraint, where } from "@angular/fire/firestore";
import { AngularFirestore } from "@angular/fire/compat/firestore";
import { ActionsSubject } from "@ngrx/store";
import { createEffect, ofType } from "@ngrx/effects";
import { catchError, from, map, mergeMap, of, switchMap, tap } from "rxjs";
import { addIncentiveData, addIncentiveDataFailure, addIncentiveDataSuccess, addIncentiveRejectedData, addIncentiveRejectedDataFailure, addIncentiveRejectedDataSuccess, cancelIncentiveRecord, cancelIncentiveRecordFailure, cancelIncentiveRecordSuccess, createIncentiveCommentRecord, createIncentiveCommentRecordFailure, createIncentiveCommentRecordSuccess, editIncentiveData, editIncentiveDataFailure, editIncentiveDataSuccess, fetchIncentiveAttachments, fetchIncentiveAttachmentsFailure, fetchIncentiveAttachmentsSuccess, fetchIncentiveCancelReasonsList, fetchIncentiveCancelReasonsListFailure, fetchIncentiveCancelReasonsListSuccess, fetchIncentiveListData, fetchIncentiveListFailure, fetchIncentiveListSuccess, fetchIncentiveMembersList, fetchIncentiveMembersListFailure, fetchIncentiveMembersListSuccess, fetchIncentiveRecordComments, fetchIncentiveRecordCommentsFailure, fetchIncentiveRecordCommentsSuccess, fetchIncentiveRejectedListData, fetchIncentiveRejectedListDataFailure, fetchIncentiveRejectedListDataSuccess, fetchSingleIncentiveRecordData, fetchSingleIncentiveRecordDataFailure, fetchSingleIncentiveRecordDataSuccess, releaseIncentiveRecord, releaseIncentiveRecordFailure, releaseIncentiveRecordSuccess, updateIncentiveStatus, updateIncentiveStatusFailure, updateIncentiveStatusSuccess } from "./incentive.actions";
import { ToastifyService } from "../../shared/toastify-service";
import { IncentiveService } from "../../core/services/incentive.service";
import { CommonAPIService } from "../../core/services/common-api.service";
import { GlobalComponent } from "../../global-component";
import { FiltersService } from "../../core/services/filters.service";

@Injectable()
export class IncentiveEffects {
    currentuser: any;
    firbasebasecollname: string = 'vendors';
    subdomaincollname: string = 'subdomains';
    vendorguid!: string;

    constructor(
        private tokenService: TokenStorageService,
        private genericService: GenericService,
        private afs: AngularFirestore,
        private actions$: ActionsSubject,
        private toastifyService: ToastifyService,
        private incentiveService: IncentiveService,
        private commonService: CommonAPIService,
        private filtersService: FiltersService
    ) { }

    async checkCondition(tabId: number) {
        console.log("checkcondition tabId...", tabId);
        this.currentuser = this.tokenService.getUser();
        const isuservendor = this.genericService.getUserIsVendor();
        const vendorCollection = collection(this.afs.firestore, `${this.firbasebasecollname}/${this.tokenService.getVendorGUID()!}/incentives`);
        console.log("vendorCollection...", vendorCollection);
        let activestateval = true;
        if (tabId == 5) {
            activestateval = false;
        }
        let baseQuery = and(where('activestate', '==', activestateval));

        const filterData: any = this.filtersService.getIncentiveSelectedFilters();
        // Adding Filter Queries to baseQuery
        if (filterData.clients && filterData.clients.length) {
            baseQuery = and(baseQuery, where("clientguid", 'in', filterData.clients));
        }

        if (filterData.states && filterData.states.length) {
            baseQuery = and(baseQuery, where("state", "in", filterData.states));
        }


        if (filterData.statuses && filterData.statuses.length) {
            baseQuery = and(baseQuery, where("jobstatus", "in", filterData.statuses));
        }

        if (filterData.daterange && filterData.daterange.length) {
            let queryby = ""
            switch (tabId) {
                case 1:
                    queryby = "createdAt"
                    break
                default:
                    queryby = "createdAt"
            }
            let startDate = new Date(filterData.daterange[0].setHours(0, 0, 0, 0));
            let endDate = new Date(filterData.daterange[0].setHours(23, 59, 59, 999));
            console.log(startDate, endDate)
            if (filterData.daterange.length === 2) {
                endDate = new Date(filterData.daterange[1].setHours(23, 59, 59, 999));
            }

            baseQuery = and(baseQuery, where(queryby, ">=", startDate.toISOString()), where(queryby, "<=", endDate.toISOString()));
        }

        const userRoleCondition = where('clientguid', '==', this.currentuser.role?.type === 'super_admin' ? this.currentuser.guid : this.currentuser.masterguid);
        let userRoleQuery: any = baseQuery;
        let memberQuery: QueryCompositeFilterConstraint | null = null;
        console.log("testCondition...", !this.currentuser.usertype || !isuservendor, isuservendor, this.currentuser)
        if (!this.currentuser.usertype || !isuservendor) {
            userRoleQuery = and(userRoleCondition, where('activestate', '==', activestateval)) as QueryCompositeFilterConstraint;
        }

        switch (tabId) {
            case 1:
                if (!isuservendor) {
                    return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['created', 'outsourced', 'accepted', 'picked'])), orderBy("createdAt", "desc"));
                }
                return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['outsourced', 'accepted', 'picked'])), orderBy("createdAt", "desc"));

            case 2:
                return query(vendorCollection, and(userRoleQuery, where('jobstatus', 'in', ['incentiveinprogress', 'incentivecompleted'])), orderBy("createdAt", "desc"));

            case 3:
                return query(vendorCollection, and(userRoleQuery, and(where('jobstatus', '==', 'incentiveapproved'))), orderBy("createdAt", "desc"));

            case 4:
                return query(vendorCollection, and(userRoleQuery, and(where('jobstatus', '==', 'incentiverejected'))), orderBy("createdAt", "desc"));

            case 5:
                return query(vendorCollection, userRoleQuery, orderBy("cancelleddate", "desc"));

            default:
                console.log('invalid tabId...', tabId);
                return query(vendorCollection, baseQuery, orderBy("createdAt", "desc"));
        }
    }

    // Create Incentive Record
    addIncentiveData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(addIncentiveData),
            mergeMap(({ postdata }) =>
                this.incentiveService.addIncentiveData(postdata).pipe(
                    tap((Incentiverecord: any) => console.log('Incentive Record:', Incentiverecord)), // Log the response
                    map((Incentiverecord: any) => {
                        console.log('addIncentiveDataSuccess action hit'); // Log success action dispatch
                        return addIncentiveDataSuccess(Incentiverecord);
                    }),
                    catchError((error) => {
                        console.error('Error adding incentive data:', error); // Log errors
                        return of(addIncentiveDataFailure({ error }));
                    })
                )
            )
        )
    );
    addIncentiveDataSuccess$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(addIncentiveDataSuccess),
                tap((user: any) => {
                    this.toastifyService.showSuccessMessage("Order created successfully");
                })
            ),
        { dispatch: false }
    );
    addIncentiveDataFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(addIncentiveDataFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // Refetch when the condition changes
    fetchIncentiveData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchIncentiveListData),
            switchMap(({ tabId }) =>
                from(this.checkCondition(tabId)).pipe(
                    switchMap(condition =>
                        collectionData(condition).pipe(
                            map((docs: any) => fetchIncentiveListSuccess({ Incentives: docs, tabid: tabId })),
                            catchError((error) => of(fetchIncentiveListFailure({ error, tabid: tabId })))
                        )
                    )
                )
            )
        )
    );

    // Fetch Incentive Record
    fetchSingleIncentiveRecordData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchSingleIncentiveRecordData),
            mergeMap(({ recordguid }) =>
                this.incentiveService.getSingleIncentiveRecordData(recordguid).pipe(
                    map((incentiverecord) => fetchSingleIncentiveRecordDataSuccess({ incentiverecord })),
                    catchError((error) => of(fetchSingleIncentiveRecordDataFailure({ error })))
                )
            ),
        ),
    );

    // Fetching and updating incentive status
    updateIncentiveStatus$ = createEffect(() =>
        this.actions$.pipe(
            ofType(updateIncentiveStatus),
            mergeMap(({ recordguid, postdata }) =>
                this.incentiveService.updateIncentiveStatus(recordguid, postdata).pipe(
                    map(() => updateIncentiveStatusSuccess()),
                    catchError((error) => of(updateIncentiveStatusFailure({ error })))
                )
            ),
        ),
    );

    // Comment create
    createIncentiveCommentRecord$ = createEffect(() =>
        this.actions$.pipe(
            ofType(createIncentiveCommentRecord),
            mergeMap(({ postdata }) =>
                this.commonService.createRecords('incentivecomments', postdata).pipe(
                    map((comment) => createIncentiveCommentRecordSuccess({ comment })),
                    catchError((error) => of(createIncentiveCommentRecordFailure({ error })))
                )
            ),
        ),
    );

    // Fetch Incentive Comments Record
    fetchIncentiveRecordComments$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchIncentiveRecordComments),
            mergeMap(({ recordguid }) =>
                this.commonService.fetchRecords('incentivecomments', recordguid, 'createdAt:DESC').pipe(
                    map((comments) => fetchIncentiveRecordCommentsSuccess({ comments: comments })),
                    catchError((error) => of(fetchIncentiveRecordCommentsFailure({ error })))
                )
            ),
        ),
    );

    fetchIncentiveRecordCommentsFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchIncentiveRecordCommentsFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // Add Incentive Rejected Record
    addIncentiveRejectedData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(addIncentiveRejectedData),
            mergeMap(({ postdata }) =>
                this.incentiveService.addIncentiveRejectedRecord(postdata).pipe(
                    map((record) => addIncentiveRejectedDataSuccess({ record })),
                    catchError((error) => of(addIncentiveRejectedDataFailure({ error })))
                )
            ),
        ),
    );

    // Fetch Incentive Rejected List
    fetchIncentiveRejectedListData$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchIncentiveRejectedListData),
            mergeMap(({ postdata }) =>
                this.incentiveService.getRejectedList(postdata).pipe(
                    map((rejectedlist) => fetchIncentiveRejectedListDataSuccess({ rejectedlist })),
                    catchError((error) => of(fetchIncentiveRejectedListDataFailure({ error })))
                )
            ),
        ),
    );

    // Fetch Incentive Team
    fetchIncentiveMembersList$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchIncentiveMembersList),
            mergeMap(({ recordguid }) =>
                this.incentiveService.getIncentiveMembersList(recordguid).pipe(
                    map((list) => fetchIncentiveMembersListSuccess({ memberslist: list })),
                    catchError((error) => of(fetchIncentiveMembersListFailure({ error })))
                )
            ),
        ),
    );
    fetchIncentiveMembersListFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchIncentiveMembersListFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // FETCH ATTACHMENTS OF Incentive RECORD
    fetchIncentiveAttachments$ = createEffect(() =>
        this.actions$.pipe(
            ofType(fetchIncentiveAttachments),
            mergeMap(({ jobguid }) =>
                this.incentiveService.getIncentivesAttachments(jobguid).pipe(
                    map((attachments) => fetchIncentiveAttachmentsSuccess({ attachments })),
                    catchError((error) => of(fetchIncentiveAttachmentsFailure({ error })))
                )
            ),
        ),
    );

    fetchIncentiveAttachmentsFailure$ = createEffect(
        () =>
            this.actions$.pipe(
                ofType(fetchIncentiveAttachmentsFailure),
                tap((error: any) => {
                    this.toastifyService.showErrorMessage(error.error.message);
                })
            ),
        { dispatch: false }
    );

    // FETCH CANCEL REASONS FROM FIREBASE
        fetchIncentiveCancelReasonsList$ = createEffect(() =>
            this.actions$.pipe(
                ofType(fetchIncentiveCancelReasonsList),
                mergeMap(() =>
                    this.afs.collection(GlobalComponent.firebasecancelreasonsbasecollname).doc('JnlKZBhKuN2yOmSiptTb')
                        .valueChanges().pipe(
                            map((docs: any) => {
                                console.log(":docs", docs)
                                return fetchIncentiveCancelReasonsListSuccess({ reasons: docs });
                            }),
                            catchError((error) =>
                                of(fetchIncentiveCancelReasonsListFailure({ error }))
                            )
                        )
                ),
            ),
        );
    
        fetchIncentiveCancelReasonsListFailure$ = createEffect(
            () =>
                this.actions$.pipe(
                    ofType(fetchIncentiveCancelReasonsListFailure),
                    tap((error: any) => {
                        this.toastifyService.showErrorMessage(error.error ? error.error.message : 'something went wrong, please check again');
                    })
                ),
            { dispatch: false }
        );

        // CANCEL INCENTIVE PROJECT
            cancelIncentiveRecord$ = createEffect(() =>
                this.actions$.pipe(
                    ofType(cancelIncentiveRecord),
                    mergeMap(({ postdata }) =>
                        this.incentiveService.cancelIncetiveProject(postdata).pipe(
                            map(() => cancelIncentiveRecordSuccess()),
                            catchError((error) => of(cancelIncentiveRecordFailure({ error })))
                        )
                    ),
                ),
            );
        
            cancelIncentiveRecordSuccess$ = createEffect(
                () =>
                    this.actions$.pipe(
                        ofType(cancelIncentiveRecordSuccess),
                        tap(() => {
                            this.toastifyService.showSuccessMessage(GlobalComponent.messages.cancelsuccess);
                        })
                    ),
                { dispatch: false }
            );
        
            cancelIncentiveRecordFailure$ = createEffect(
                () =>
                    this.actions$.pipe(
                        ofType(cancelIncentiveRecordFailure),
                        tap((error: any) => {
                            this.toastifyService.showErrorMessage(error.error.message);
                        })
                    ),
                { dispatch: false }
            );

        // Edit Incentive Record
            editIncentiveData$ = createEffect(() =>
                this.actions$.pipe(
                    ofType(editIncentiveData),
                    mergeMap(({ postdata, recordId }) =>
                        this.incentiveService.editIncentiveData(postdata, recordId).pipe(
                            map((Incentiverecord) => editIncentiveDataSuccess(Incentiverecord)),
                            catchError((error) => of(editIncentiveDataFailure({ error })))
                        )
                    ),
                ),
            );
        
            editIncentiveDataSuccess$ = createEffect(
                () =>
                    this.actions$.pipe(
                        ofType(editIncentiveDataSuccess),
                        tap((user: any) => {
                            this.toastifyService.showSuccessMessage("Order updated successfully");
                        })
                    ),
                { dispatch: false }
            );
        
            editIncentiveDataFailure$ = createEffect(
                () =>
                    this.actions$.pipe(
                        ofType(editIncentiveDataFailure),
                        tap((error: any) => {
                            this.toastifyService.showErrorMessage(error.error.message);
                        })
                    ),
                { dispatch: false }
            );

            releaseIncentiveRecord$ = createEffect(() =>
                    this.actions$.pipe(
                        ofType(releaseIncentiveRecord),
                        mergeMap(({ recordguid, postdata }) =>
                            this.incentiveService.releaserecord(recordguid, postdata).pipe(
                                map(() => releaseIncentiveRecordSuccess()),
                                catchError((error) => of(releaseIncentiveRecordFailure({ error })))
                            )
                        ),
                    ),
                );
            
                releaseIncentiveRecordSuccess$ = createEffect(
                    () =>
                        this.actions$.pipe(
                            ofType(releaseIncentiveRecordSuccess),
                            tap(() => {
                                this.toastifyService.showSuccessMessage("Record released successfully");
                                // this.router.navigate(['../']);
                            })
                        ),
                    { dispatch: false }
                );
            
                releaseIncentiveRecordFailure$ = createEffect(
                    () =>
                        this.actions$.pipe(
                            ofType(releaseIncentiveRecordFailure),
                            tap((error: any) => {
                                console.log('error', error);
                                this.toastifyService.showErrorMessage(error.error.message);
                            })
                        ),
                    { dispatch: false }
                );
}